import axios from "axios";

const API_URL = `${process.env.REACT_APP_BASE_URL}/auth`;

// Função para realizar o login e armazenar o token
const login = async (email, password) => {
  const res = await axios.post(`${API_URL}/login`, { email, password });
  if (res.data.token) {
    localStorage.setItem("token", res.data.token);
  }
  return res.data;
};

// Função para deslogar e remover o token
const logout = () => {
  localStorage.removeItem("token");
};

// Função para validar o token chamando a rota que retorna os dados do usuário
const validateToken = async () => {
  const token = localStorage.getItem("token");
  if (!token) return false;
  try {
    await axios.get(`${API_URL}/user`, {
      headers: { "x-auth-token": token }
    });
    return true;
  } catch (error) {
    localStorage.removeItem("token");
    return false;
  }
};

// Configuração global do Axios para interceptar respostas de erro de autenticação
axios.interceptors.response.use(
  response => response,
  error => {
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      localStorage.removeItem("token");
      window.location.href = "/"; // Redireciona para a tela de login
    }
    return Promise.reject(error);
  }
);

export { login, logout, validateToken };
